import { SxProps, TextField as MuiTextField, Theme } from '@mui/material'
import React, { ChangeEvent, FocusEventHandler } from 'react'

type TextFieldDatePickerProps = {
  id?: string
  label: string
  required?: boolean
  name: string
  value?: string
  placeholder?: string
  maxLength?: number
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  onKeyDown?: (e: any) => void
  minRows?: number
  multiline?: boolean
  errorText?: React.ReactNode
  sx?: SxProps<Theme>
  error?: boolean
}

const TextField: React.FC<TextFieldDatePickerProps> = ({
  id,
  label,
  required,
  name,
  value,
  placeholder,
  maxLength,
  onChange,
  onBlur,
  multiline,
  minRows,
  errorText,
  sx,
  error,
  onKeyDown,
}) => {
  return (
    <MuiTextField
      fullWidth
      id={id}
      required={required}
      label={label}
      name={name}
      value={value}
      size='small'
      placeholder={placeholder}
      onChange={onChange}
      InputProps={{
        inputProps: {
          maxLength: maxLength,
        },
      }}
      minRows={minRows}
      onKeyDown={onKeyDown}
      multiline={multiline}
      sx={sx}
      onBlur={onBlur}
      helperText={errorText}
      error={error}
    />
  )
}

export default TextField
